function dataForImages(arr, full) {
    let res = [];
    for (let idx = 0; idx < arr.length; idx++) {
        const element = arr[idx];
        const fullPath = full ? full[idx] : element;
        res.push({
            detail: "Screenshot " + (idx + 1),
            alt: "Screenshot " + (idx + 1),
            path: "./images/" + element,
            src: "./images/" + fullPath,
            style: "object-fit: contain; max-height:80vh",
            class: "svelte-lightbox-image-portrait"
        });
    }
    return res;
}

export let ddwItems = dataForImages(["ddw/1x.jpg", "ddw/2x.jpg", "ddw/3x.jpg", "ddw/4x.jpg"], ["ddw/full/1x.jpg", "ddw/full/2x.jpg", "ddw/full/3x.jpg", "ddw/full/4x.jpg"]);
export let puzzleItems = dataForImages(["puzzle/1x.jpg", "puzzle/2x.jpg", "puzzle/3x.jpg", "puzzle/4x.jpg"], ["puzzle/full/1x.jpg", "puzzle/full/2x.jpg", "puzzle/full/3x.jpg", "puzzle/full/4x.jpg"]);
export let diceItems = dataForImages(["dice/1x.jpg", "dice/2x.jpg", "dice/3x.jpg", "dice/4x.jpg"], ["dice/full/1x.jpg", "dice/full/2x.jpg", "dice/full/3x.jpg", "dice/full/4x.jpg"]);
export let asoundsItems = dataForImages(["asounds/1x.jpg", "asounds/2x.jpg", "asounds/3x.jpg", "asounds/4x.jpg"], ["asounds/full/1x.jpg", "asounds/full/2x.jpg", "asounds/full/3x.jpg", "asounds/full/4x.jpg"]);
export let tatatuItems = dataForImages(["tatatu/1x.jpg", "tatatu/2x.jpg", "tatatu/3x.jpg", "tatatu/4x.jpg"], null);
export let soundlyItems = dataForImages(["soundly/1x.jpg", "soundly/2x.jpg", "soundly/3x.jpg", "soundly/4x.jpg"], null);
